import { api, API_ENDPOINTS } from '../lib/api';
import { BackendLocation } from '../types/location';

export const favoritesService = {
  getFavorites: async (latitude?: number, longitude?: number): Promise<BackendLocation[]> => {
    const params: Record<string, number> = {};
    if (latitude !== undefined) params.latitude = latitude;
    if (longitude !== undefined) params.longitude = longitude;

    const response = await api.get<BackendLocation[]>(API_ENDPOINTS.FAVORITES.BASE, { params });
    return Array.isArray(response.data) ? response.data : [];
  },

  addFavorite: async (locationId: string): Promise<void> => {
    await api.post(API_ENDPOINTS.FAVORITES.BY_ID(locationId));
  },

  removeFavorite: async (locationId: string): Promise<void> => {
    await api.delete(API_ENDPOINTS.FAVORITES.BY_ID(locationId));
  },
};
